import { call, put, takeEvery } from 'redux-saga/effects';
import { DeactivateProspect, IProspectApiResponse, prospectActionCreators, ProspectsActionKeys } from '..';
import { IEntityWithMessages } from '../../../services/HttpService';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { processMessages, showFailedRequestDialog } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';
import * as api from '../prospectsApi';

function* deactivateProspectSaga(action: DeactivateProspect) {
  yield put(uiActionCreators.showSpinnerDialog());

  const response: IApiExecuteRespone<IEntityWithMessages<IProspectApiResponse>> = yield call(
    api.DeactivateProspect,
    action.payload
  );

  if (!response.requestFailed && response.value) {
    yield processMessages(response.value);

    if (response.value.value) {
      yield put(prospectActionCreators.updateProspectFulfilled(response.value.value));
    }
  } else {
    yield showFailedRequestDialog(response);
  }

  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchDeactivateProspect() {
  yield takeEvery(ProspectsActionKeys.DEACTIVATE_PROSPECT, deactivateProspectSaga);
}
